import { jsx } from "react/jsx-runtime";
import { COMMON_CLASSNAME } from "../../../constants.js";
function FlashBrandIcon(props) {
  const { img, size } = props;
  let imgSrc = img;
  (img.startsWith("<svg") || img.startsWith("<?xml")) && (imgSrc = `data:image/svg+xml,${encodeURIComponent(img)}`);
  const dimensionSize = size ?? 40;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `${COMMON_CLASSNAME} flash-brand-icon d-flex align-items-center justify-content-center border rounded overflow-hidden`,
      style: {
        height: `${dimensionSize}px`,
        width: `${dimensionSize}px`
      },
      children: /* @__PURE__ */ jsx("img", { src: imgSrc, height: dimensionSize, width: dimensionSize })
    }
  );
}
export {
  FlashBrandIcon as default
};
//# sourceMappingURL=FlashBrandIcon.js.map
